@if (locationStats) {
  <div class="location-stats">
    <section>
      <div class="row">
        <div class="col-wide">Lokationer</div>
        <div class="col">
          {{ locationStats.locationCount }}
        </div>
      </div>
      <div class="row">
        <div class="col-wide">Ladestandere</div>
        <div class="col">
          {{ locationStats.chargingStationCount === -1 ? '?' : locationStats.chargingStationCount }}
        </div>
      </div>
      <div class="row">
        <div class="col-wide">Ladepunkter</div>
        <div class="col">
          {{ locationStats.connectorCount }}
        </div>
      </div>
      <div class="row">
        <div class="col-full connector-speed">
          <div class="icon-with-text cursor-help" [matTooltip]="locationStats.slowConnectorCount + ' Normalladere'">
            <mat-checkbox class="checkbox" (change)="emitChargingSpeedClick(chargingSpeed.Normal)" checked>
              <mat-icon svgIcon="charging_green" aria-hidden="false"></mat-icon>
            </mat-checkbox>
          </div>
          <div class="icon-with-text cursor-help" [matTooltip]="locationStats.fastConnectorCount + ' Hurtigladere'">
            <mat-checkbox class="checkbox" (change)="emitChargingSpeedClick(chargingSpeed.Fast)" checked>
              <mat-icon svgIcon="charging_orange" aria-hidden="false"></mat-icon>
            </mat-checkbox>
          </div>
          <div class="icon-with-text cursor-help" [matTooltip]="locationStats.rapidConnectorCount + ' Lynladere'">
            <mat-checkbox class="checkbox" (change)="emitChargingSpeedClick(chargingSpeed.Super)" checked>
              <mat-icon svgIcon="charging_orange_burnt" aria-hidden="false"></mat-icon>
            </mat-checkbox>
          </div>
        </div>
      </div>
    </section>
  </div>
}
